import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-tile',
  imports: [],
  templateUrl: './icon-tile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./icon-tile.component.scss'],
})
export class IconTileComponent {
  @Input({ required: true }) label: string;
  @Input({ required: true }) text: string;
  @Input({ required: true }) iconPath: string;
}
